import { Divider, Empty, Typography } from 'antd';
import React, { useMemo } from 'react';
import { useAccount } from 'wagmi';

import IssueList from '@/component/IssueList';
import issues from '@/data/issues';
import checkAdmin from '@/libs/checkAdmin';
const { Title } = Typography;

function MyIssues() {
  const { address } = useAccount();
  const isAdmin = checkAdmin(address);
  const issueArray = useMemo(() => (isAdmin ? issues.slice(1, 3) : []), [isAdmin]);

  return (
    <>
      <Title>My Issues</Title>
      <Divider />
      {isAdmin ? (
        <IssueList issues={issueArray} isEditMode={true} />
      ) : (
        <Empty imageStyle={{ height: 150 }} description="Sorry, only Admin role could add issue." />
      )}
    </>
  );
}

export default MyIssues;
